(function () {
  'use strict';

  if (window.GMVCRMTracker) return;

  var SFDC_HOST_KEYWORD = 'sententertainment.my.site.com';
  var recentResults = [];
  var MAX_RESULTS = 30;

  function nowTs() {
    return Date.now();
  }

  function isSfdcUrl(url) {
    return typeof url === 'string' && url.indexOf(SFDC_HOST_KEYWORD) !== -1;
  }

  function parseMaybeJson(value) {
    if (value == null) return null;
    if (typeof value === 'string') {
      if (!value.trim()) return '';
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
    if (typeof URLSearchParams !== 'undefined' && value instanceof URLSearchParams) {
      var out = {};
      value.forEach(function (v, k) { out[k] = v; });
      return out;
    }
    return value;
  }

  function emitResult(detail) {
    var enriched = detail || {};
    enriched.ts = enriched.ts || nowTs();
    recentResults.push(enriched);
    if (recentResults.length > MAX_RESULTS) recentResults.shift();
    try {
      window.dispatchEvent(new CustomEvent('gmv-crm-network-result', { detail: enriched }));
    } catch (e) {}
  }

  function installNetworkMonitor() {
    if (window.__gmvCrmNetworkMonitorInstalled) return;
    window.__gmvCrmNetworkMonitorInstalled = true;

    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var watch = isSfdcUrl(url);
        var startedAt = nowTs();
        var requestPayload = init && 'body' in init ? parseMaybeJson(init.body) : null;
        var req = originalFetch.apply(this, arguments);
        if (!watch) return req;

        return req.then(function (res) {
          var baseDetail = {
            transport: 'fetch',
            url: url,
            request: requestPayload,
            status: res && typeof res.status === 'number' ? res.status : 0,
            ok: !!(res && res.ok),
            durationMs: nowTs() - startedAt,
            event: 'load'
          };

          if (!res || typeof res.clone !== 'function') {
            emitResult(baseDetail);
            return res;
          }

          return res.clone().text().then(function (text) {
            baseDetail.response = parseMaybeJson(text);
            emitResult(baseDetail);
            return res;
          }).catch(function () {
            emitResult(baseDetail);
            return res;
          });
        }).catch(function (err) {
          emitResult({
            transport: 'fetch',
            url: url,
            request: requestPayload,
            status: 0,
            ok: false,
            durationMs: nowTs() - startedAt,
            event: 'error',
            error: err && err.message ? err.message : String(err)
          });
          throw err;
        });
      };
    }

    if (window.XMLHttpRequest) {
      var xhrOpen = XMLHttpRequest.prototype.open;
      var xhrSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__gmvCrmTrack = {
          method: method || '',
          url: typeof url === 'string' ? url : '',
          watch: isSfdcUrl(typeof url === 'string' ? url : ''),
          startedAt: 0,
          request: null
        };
        return xhrOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function (body) {
        var xhr = this;
        var track = xhr.__gmvCrmTrack;
        if (track && track.watch) {
          track.startedAt = nowTs();
          track.request = parseMaybeJson(body);
          var reported = false;
          var report = function (eventName) {
            if (reported) return;
            reported = true;
            var status = xhr.status || 0;
            emitResult({
              transport: 'xhr',
              method: track.method,
              url: track.url,
              request: track.request,
              response: parseMaybeJson(xhr.responseText),
              status: status,
              ok: status >= 200 && status < 300,
              durationMs: nowTs() - track.startedAt,
              event: eventName
            });
          };
          xhr.addEventListener('loadend', function () { report('loadend'); });
          xhr.addEventListener('error', function () { report('error'); });
          xhr.addEventListener('abort', function () { report('abort'); });
          xhr.addEventListener('timeout', function () { report('timeout'); });
        }
        return xhrSend.apply(this, arguments);
      };
    }

    if (navigator && typeof navigator.sendBeacon === 'function') {
      var originalSendBeacon = navigator.sendBeacon.bind(navigator);
      navigator.sendBeacon = function (url, data) {
        var watch = isSfdcUrl(url);
        var startedAt = nowTs();
        var ok = originalSendBeacon(url, data);
        if (watch) {
          emitResult({
            transport: 'beacon',
            url: typeof url === 'string' ? url : '',
            request: parseMaybeJson(data),
            response: null,
            status: ok ? 202 : 0,
            ok: !!ok,
            durationMs: nowTs() - startedAt,
            event: 'sendBeacon'
          });
        }
        return ok;
      };
    }

    console.log('[CRM] network monitor installed');
  }

  function findRecentResult(sinceTs) {
    for (var i = recentResults.length - 1; i >= 0; i--) {
      if (recentResults[i].ts >= sinceTs) return recentResults[i];
    }
    return null;
  }

  function waitForSfdcResult(options) {
    var opts = options || {};
    var timeoutMs = typeof opts.timeoutMs === 'number' ? opts.timeoutMs : 1800;
    var sinceTs = typeof opts.sinceTs === 'number' ? opts.sinceTs : nowTs();
    var existing = findRecentResult(sinceTs);
    if (existing) return Promise.resolve(existing);

    return new Promise(function (resolve) {
      var done = false;
      function finish(result) {
        if (done) return;
        done = true;
        window.removeEventListener('gmv-crm-network-result', onResult);
        clearTimeout(timer);
        resolve(result || null);
      }
      function onResult(e) {
        var detail = e && e.detail;
        if (detail && detail.ts >= sinceTs) finish(detail);
      }
      var timer = setTimeout(function () { finish(null); }, timeoutMs);
      window.addEventListener('gmv-crm-network-result', onResult);
    });
  }

  function sendResultToApi(options) {
    var opts = options || {};
    var apiUrl = (opts.apiUrl || '').trim();
    if (!apiUrl) return Promise.resolve({ skipped: true, reason: 'missing-api-url' });

    var headers = { 'Content-Type': 'application/json' };
    if (opts.apiKey) headers['X-API-Key'] = opts.apiKey;

    var body = {
      id_form: opts.idForm || '',
      email: opts.email || '',
      request: opts.request || {},
      response: opts.response || {},
      status: opts.status || 'unknown'
    };

    return fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        return {
          ok: res.ok,
          status: res.status,
          response: parseMaybeJson(text)
        };
      }).catch(function () {
        return { ok: res.ok, status: res.status, response: null };
      });
    });
  }

  function reportSubmission(options) {
    var opts = options || {};
    var startedAt = opts.startedAt || nowTs();
    var timeoutMs = typeof opts.waitTimeoutMs === 'number' ? opts.waitTimeoutMs : 1800;
    installNetworkMonitor();
    return waitForSfdcResult({ sinceTs: startedAt, timeoutMs: timeoutMs }).then(function (networkResult) {
      var fallbackResult = opts.networkResultOverride || null;
      var finalResult = networkResult || fallbackResult;
      var status = 'pending';
      if (finalResult) status = finalResult.ok ? 'success' : 'failed';
      return sendResultToApi({
        apiUrl: opts.apiUrl,
        apiKey: opts.apiKey,
        idForm: opts.idForm,
        email: opts.email,
        request: opts.request,
        response: finalResult || { message: 'No SFDC network result within timeout' },
        status: status
      }).then(function (apiResult) {
        return { networkResult: networkResult, fallbackResult: fallbackResult, apiResult: apiResult };
      });
    });
  }

  function buildSfdcSubmitUrl(baseUrl, formId) {
    var safeBase = String(baseUrl || '').replace(/\/$/, '');
    return safeBase + '/services/data/v65.0/connect/form-handler/' + encodeURIComponent(formId) + '/submit';
  }

  function getSalesforceAnonymousId() {
    try {
      if (typeof SalesforceInteractions === 'undefined') return '';
      if (typeof SalesforceInteractions.currentConsentOptInExists === 'function' && !SalesforceInteractions.currentConsentOptInExists()) return '';
      if (typeof SalesforceInteractions.getAnonymousId === 'function') return SalesforceInteractions.getAnonymousId() || '';
    } catch (e) {}
    return '';
  }

  function submitSfdcForm(options) {
    var opts = options || {};
    var baseUrl = (opts.baseUrl || '').trim();
    var formId = (opts.formId || '').trim();
    if (!baseUrl) return Promise.reject(new Error('missing baseUrl'));
    if (!formId) return Promise.reject(new Error('missing formId'));
    installNetworkMonitor();
    var submitUrl = buildSfdcSubmitUrl(baseUrl, formId);
    var body = {
      formData: opts.formData || {},
      uniqueId: getSalesforceAnonymousId()
    };
    if (opts.token) body.token = opts.token;

    return fetch(submitUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        var parsed = parseMaybeJson(text);
        if (!res.ok) {
          var err = new Error('SFDC submit failed ' + res.status);
          err.status = res.status;
          err.response = parsed;
          throw err;
        }
        return { ok: true, status: res.status, response: parsed };
      });
    });
  }

  window.GMVCRMTracker = {
    installNetworkMonitor: installNetworkMonitor,
    waitForSfdcResult: waitForSfdcResult,
    sendResultToApi: sendResultToApi,
    reportSubmission: reportSubmission,
    submitSfdcForm: submitSfdcForm
  };
})();
